<div @slideDownUp class="flex flex-col justify-between items-center gap-2 p-4 rounded-3xl"
    *ngIf="ready">


    <div 
        class=" relative card-primary m-0 backdrop-blur-none p-2 w-full rounded-3xl flex justify-center items-center ">
        <!--  -->

        

            <!-- <div class="flex  justify-center items-center w-full gap-2">

                <div class="flex flex-col text-center w-full justify-start items-center p-2 rounded-2xl cursor-pointer hover:bg-primary-300 hover:text-primary-50  transition-all duration-300 {{pageName == 'memory' ? 'bg-primary-500 text-primary-50' : 'text-primary-600'}}"
                    (click)="navigateTo('memory')" tabindex="0">
                    <div class="flex flex-col items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="w-12 h-12">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M12 4l-8 4l8 4l8 -4l-8 -4" />
                            <path d="M4 12l8 4l8 -4" />
                            <path d="M4 16l8 4l8 -4" />
                        </svg>
                    </div>
                    <div @slideDownUp class="flex items-center justify-center font-semibold">
                        Memoria e cache
                    </div>
                </div>
            

                <div class="flex flex-col text-center w-full justify-start items-center p-2 rounded-2xl cursor-pointer hover:bg-primary-300 hover:text-primary-50  transition-all duration-300 {{pageName == 'style' ? 'bg-primary-500 text-primary-50' : 'text-primary-600'}}"
                    (click)="navigateTo('style')" tabindex="0">
                    <div class="flex flex-col items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="w-12 h-12">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path
                                d="M12 21a9 9 0 0 1 0 -18c4.97 0 9 3.582 9 8c0 1.06 -.474 2.078 -1.318 2.828c-.844 .75 -1.989 1.172 -3.182 1.172h-2.5a2 2 0 0 0 -1 3.75a1.3 1.3 0 0 1 -1 2.25" />
                            <path d="M8.5 10.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                            <path d="M12.5 7.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                            <path d="M16.5 10.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                        </svg>
                    </div>
                    <div @slideDownUp class="flex items-center justify-center font-semibold" >
                        <p>Aspetto</p>
                    </div>
                </div>
            

                <div *ngIf="fuhrer"
                    class="flex flex-col text-center w-full justify-start items-center p-2 rounded-2xl cursor-pointer hover:bg-primary-300 hover:text-primary-50  transition-all duration-300 {{pageName == 'files' ? 'bg-primary-500 text-primary-50' : 'text-primary-600'}}"
                    (click)="navigateTo('files')" tabindex="0">
                    <div class="flex flex-col items-center justify-center">

                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                            class="w-12 h-12">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M3 4m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z" />
                            <path d="M5 8v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-10" />
                            <path d="M10 12l4 0" />
                        </svg>
                    </div>
                    <div @slideDownUp class="flex items-center justify-center font-semibold">
                        <p>Files</p>
                    </div>
                </div>


            </div> -->

            <!-- <div class="flex w-full justify-start items-center p-2 rounded-2xl cursor-pointer  hover:text-primary-50 text-primary-500  transition-all duration-300"
                tabindex="0" (click)="hideShow()">

                <div class="flex w-16 items-center justify-center" *ngIf="!sidebarOpen">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="w-12 h-12">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z" />
                        <path d="M9 4v16" />
                        <path d="M14 10l2 2l-2 2" />
                    </svg>
                </div>
                <div class="flex w-16 items-center justify-center" *ngIf="sidebarOpen">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="w-12 h-12">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z" />
                        <path d="M9 4v16" />
                        <path d="M15 10l-2 2l2 2" />
                    </svg>
                </div>


        
        </div> -->


    </div>

    <div class="bg-none  m-0 rounded-3xl w-full transition-all duration-300"
        style="min-height: 80vh;max-height: 80vh;overflow: scroll;">

        <div class=" text-text rounded-2xl transition-all duration-300 shadow-sm p-4 relative flex flex-col ">
            <div class="top-0 w-full mb-2 flex justify-between items-center">

                <div class="flex">

                    <div class="text-lg">
                        Versione: <span><b>{{version}}</b></span>
                    </div>
                </div>
            </div>

            <div class="h-full">
                <router-outlet></router-outlet>
            </div>

        </div>
    </div>
</div>